import { Interpolation, Theme } from '@emotion/react'
import { ButtonHTMLAttributes } from 'react'

import { styles } from './styles'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean
  extendStyle?: Interpolation<Theme>
  dataTestId?: string
}

// Button provides a universal button.
// Used on Delivery, Shipping, Payment screens
export function Button({
  loading,
  extendStyle,
  children,
  dataTestId,
  disabled,

  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      {...props}
      disabled={loading || disabled}
      css={[styles.button, loading && styles.loading, extendStyle]}
      tabIndex={0}
      data-testid={dataTestId}
    >
      {children}
    </button>
  )
}
